
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {createcontactokdnr3 } from '../../api/contactokdnr3.api'

import './paginaprincipalkmvgt.scss';






const Ppaginaprincipalkmvgt = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  
  
  

  
  return (
    <div id="id689784de8e5aed52dc7b4838" >

      <div id="idcr" className="">
      
      <div id="if3j" className="">
      
      <div id="iuk9j" className="">
      
        <a
          target=""
          className="link-menu "
          id="ij9z9"
          href="#sobremi"
        >
          
    <div id="id9bi" className="">
    <>Sobre mi</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i0vzh"
          href="#experiencia"
        >
          
    <div id="izdhk" className="">
    <>Experiencia</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ibddn"
          href="#educacion"
        >
          
    <div id="ih96q" className="">
    <>Educación</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iehu4"
          href="#libros"
        >
          
    <div id="iiytk" className="">
    <>Libros</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ig72a"
          href="#contacto"
        >
          
    <div id="i1ciz" className="">
    <>Contáctame</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="sobremi" className="">
      
      <div id="i0xj4" className="container-iinfo ">
      
      <div
        id="iu56u"
        className=""
        data-aos="fade-down"
        data-aos-duration="1000"
      >
      
      <div className="" id="i9uyo">
        <>Carlos G. Cálix</>
      </div>
      
      <div className="" id="ixc9i">
        <>Datos, análisis y estrategia</>
      </div>
      
      <div id="ic00c" className="">
      
        <a
          target="_blank"
          className=""
          id="iujse"
          href="https://www.instagram.com/carlosgcalix/"
        >
          
      <img
        className=""
        id="ihuc7"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4jj58l.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="iqonj"
          href="https://www.linkedin.com/in/carlos-g-c%C3%A1lix-27b524a3/"
        >
          
      <img
        className=""
        id="i294r"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4jktmy.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ijlbk"
          href="https://www.facebook.com/carlosgcalix"
        >
          
      <img
        className=""
        id="irgkr"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4jl24g.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div className="" id="icomn">
        <>Como Co-fundador de Gobai Ventures Inc., mi rol principal es el de Chief Strategy Officer (CSO). Mi trabajo principal como director de estrategia se centra en la captación de fondeadores y desarrollo estratégico del negocio para la incidencia política y empresarial. También soy CEO de M2Global Insights en donde proveo Big Data personalizada y soluciones de tecnología para resolver problemas complejos.</>
      </div>
      
      </div>
      
      <div
        id="ixxtg"
        className=""
        data-aos="zoom-in-up"
        data-aos-duration="1200"
      >
      
      <div
        id="i0mpv"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <img
        className=""
        id="iahm5"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgim52lj.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="isoz4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgim36mr.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="educacion" className="">
      
      <div id="i4s2no" className="container-iinfo ">
      
      <div id="i2uymt" className="">
      
      <div
        id="iushzj"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div className="" id="iqyhyl">
        <>Formación Académica</>
      </div>
      
      <img
        className=""
        id="i6ajv5"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4kkx5r.png"
        alt="undefined"
      />
      
      <div id="irpne9" className="">
      
      </div>
      
      </div>
      
      <div
        id="i63f8f"
        className="bloques-info "
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="titulo " id="iuwuay">
        <>Universidad de Salamanca, España.</>
      </div>
      
      <div className="descripcion " id="i1gjpc">
        <>Posdoctorado Iberoamericano en Retos para la Gobernanza Pública </>
      </div>
      
      <div className="titulo " id="i7ticj">
        <>Consejo Nacional de Investigaciones Científicas y Técnicas (CONICET), Argentina.</>
      </div>
      
      <div className="descripcion " id="ig0je2">
        <>Posdoctorado Instituto de Investigaciones Económicas y Sociales del Sur (IIESS)</>
      </div>
      
      <div className="titulo " id="igvi3i">
        <>Universidad Católica de Honduras.</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion " id="inpad6">
        <>Doctor en Ciencias con Orientación en Ciencias Administrativas </>
      </div>
      
      <div className="titulo " id="idwkc5">
        <>Centro Latinoamericano para el Desarrollo, la Integración y la Cooperación (CELADIC). Panamá.</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion " id="idx5ql">
        <>Especialidad en Desarrollo Humano Integral  </>
      </div>
      
      <div className="titulo " id="ivd67x">
        <>Escuela de finanzas (AFI). España.</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion " id="i11bde">
        <>Programa Especialidad en Fintech y Banca Digital  </>
      </div>
      
      <div className="titulo " id="i5cogs">
        <>Universidad EAN. Colombia.</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion " id="iuk5gk">
        <>Diplomado en Emprendimiento e Innovación  </>
      </div>
      
      <div className="titulo " id="ih2aef">
        <>Universidad Católica de Honduras.</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion " id="ifz9uo">
        <>Master en Administración de Empresas con elección en Gestión de la Calidad Total  </>
      </div>
      
      <div className="titulo " id="i1d8ch">
        <>Universidad Nacional Autónoma de Honduras.</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion " id="i206a7">
        <>Licenciado en Administración de Empresas   </>
      </div>
      
      </div>
      
      </div>
      
      <div
        id="i4di62"
        className=""
        data-aos="zoom-in-up"
        data-aos-duration="1200"
      >
      
      <img
        className=""
        id="io4mzm"
        src="https://assetsprojects.s3.amazonaws.com/404pziimggvccza.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="experiencia" className="">
      
      <div id="i9q28" className="container-iinfo ">
      
      <div
        id="ilqo8"
        className=""
        data-aos="zoom-in-up"
        data-aos-duration="1200"
      >
      
      <img
        className=""
        id="i6xta"
        src="https://assetsprojects.s3.amazonaws.com/404pziimggvaed7.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ihzp3" className="">
      
      <div
        id="i7mef"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="iecoo" className="">
      
      </div>
      
      <div className="" id="ijst5">
        <>Experiencia</>
      </div>
      
      <img
        className=""
        id="injpk"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4k4phw.png"
        alt="undefined"
      />
      
      </div>
      
      <div
        id="ibn7xc"
        className="bloques-info "
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="titulo " id="icxgv">
        <>Co-Fundador y CSO de Gobai Ventures, INC.</>
      </div>
      
      </div>
      
      <div
        id="if28pu"
        className="bloques-info "
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="titulo " id="ihsm62">
        <>CEO de M2Global Insights</>
      </div>
      
      </div>
      
      <div
        id="ico2af"
        className="bloques-info "
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="titulo " id="ia5mcu">
        <>Co-Fundador de Grupo Lix.</>
      </div>
      
      </div>
      
      <div
        id="ix0jsj"
        className="bloques-info "
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="titulo " id="i7km5m">
        <>Fellow Central American Leadership Iniciative con el apoyo del Aspen Institute.</>
      </div>
      
      </div>
      
      <div
        id="i8t35l"
        className="bloques-info "
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="titulo " id="i0rwo6">
        <>Directivo de la Comunidad de Emprendedores de Honduras (CEMPRENDE ).</>
      </div>
      
      </div>
      
      <div
        id="iesptt"
        className="bloques-info "
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="titulo " id="ixj3v9">
        <>Investigador, Grupo de Investigación Hernán Pedro Vigier, IIESS-CONICET, Universidad Nacional del Sur-ARG.</>
      </div>
      
      </div>
      
      <div
        id="i8zfuf"
        className="bloques-info "
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="titulo " id="ixnyl9">
        <>Miembro fundador del Proyecto Tercera República. </>
      </div>
      
      </div>
      
      <div
        id="i0mwrj"
        className="bloques-info "
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="titulo " id="iapqty">
        <>Director del Consejo Académico de Fundación Eléutera.</>
      </div>
      
      </div>
      
      <div
        id="iogmog"
        className="bloques-info "
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="titulo " id="icl7nb">
        <>Galardonado como empresario con potencial de crecimiento por el Consejo Hondureño de la Empresa Privada (COHEP) en 2018.</>
      </div>
      
      </div>
      
      <div
        id="iibmrh"
        className="bloques-info "
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="titulo " id="idplm">
        <>Top 10 de los jóvenes más sobresalientes de Honduras a través de los Premios TOYP de la Cámara Junior Internacional (JCI) en 2019. </>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="libros" className="">
      
      <div id="isuzoh" className="container-iinfo ">
      
      <div id="i9gefa" className="">
      
      <div
        id="icwiga"
        className=""
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="itfpxh" className="">
      
      </div>
      
      <div id="ieavax" className="">
      
      <div className="" id="insq4s">
        <>Libros</>
      </div>
      
      <img
        className=""
        id="ifthnl"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4mr0yu.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="ic08kw" className="">
      
      <div className="" id="iki2gt">
        <>Carlos G. Cálix es Doctor en Ciencias con orientación en Ciencias Administrativas, Summa Cum Laude. Posee posdoctorados en Argentina y España, y una trayectoria marcada por la excelencia académica y el liderazgo estratégico.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Ha dirigido instituciones financieras, cofundado firmas de análisis económico y asesorado a empresas en su crecimiento. Es autor de 13 libros y columnista en medios internacionales, donde comparte su visión sobre economía, liderazgo y transformación social.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Apasionado por la educación, ha sido profesor e invitado en prestigiosas universidades de Latinoamérica y Europa, inspirando a nuevas generaciones a pensar estratégicamente y liderar con propósito.</>
      </div>
      
      <img
        className=""
        id="isbdx2"
        src="https://assetsprojects.s3.amazonaws.com/404pziimggvdp51.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i1xmks" className="">
      
      <img
        className="img-book "
        id="ingu8q"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4mxd5r.png"
        alt="undefined"
      />
      
      <img
        className="img-book "
        id="imjlys"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4mxew7.png"
        alt="undefined"
      />
      
      <img
        className="img-book "
        id="i2nchk"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4mxfs4.png"
        alt="undefined"
      />
      
      <img
        className="img-book "
        id="i189co"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4mxgmw.png"
        alt="undefined"
      />
      
      <img
        className="img-book "
        id="is1477"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4mxhha.png"
        alt="undefined"
      />
      
      <img
        className="img-book "
        id="igtd0j"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4mxibn.png"
        alt="undefined"
      />
      
      <img
        className="img-book "
        id="i93yml"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4mxj9i.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="im1x1" className="">
      
      <div
        id="iubi56"
        className="container-iinfo "
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <img
        className=""
        id="iw5uol"
        src="https://assetsprojects.s3.amazonaws.com/404pziimggvm0o8.png"
        alt="undefined"
      />
      
      <div id="iiz75u" className="">
      
      <div className="" id="ict6zz">
        <>Calos G. Cálix</>
      </div>
      
      <div className="" id="i34ujn">
        <>El verdadero liderazgo nace de la capacidad de anticipar el futuro y construirlo con propósito.</>
      </div>
      
      <img
        className=""
        id="ii00fg"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4n3kdk.png"
        alt="undefined"
      />
      
      <div className="" id="id8tll">
        <>Carlos G. Cálix es doctor en ciencias y Co-Fundador y CSO de Gobai Ventures, INC. Y es CEO de M2Global Insights. Se enfoca en análisis de datos y estrategias. Casado, reside entre Miami y Tegucigalpa.</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="contacto" className="">
      
      <div
        id="ifittv"
        className="container-iinfo "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="ixdj1k" className="">
      
      <div
        id="ifa6ds"
        className=""
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="i19yc4" className="">
      
      </div>
      
      <div id="imkdit" className="">
      
      <div className="" id="io7hwg">
        <>Contáctame</>
      </div>
      
      <img
        className=""
        id="ips189"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4nndbw.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="ibhsgl" className="">
      
      <div className="" id="igplt8">
        <>Conferencias y seminarios</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="iajd5q">
        <>Para contratación de conferencias, seminarios, apariciones y colaboraciones en Medios de comunicación o en TV</>
      </div>
      
        <div className="" id="id015c">
          
      <form
        id="ijj5f7"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createcontactokdnr3({
						token: 'aasdas',
				nombrejivad: e.target.nombrejivad.value,
						correoirnp8: e.target.correoirnp8.value,
						telfono8f0j3g: e.target.telfono8f0j3g.value,
					});
					alert("Se envio exitosamente.");
		} catch (error) {
					console.log(error);
				}
			}}
		
      >
        
      <div id="ivt6yo" className="">
      
      <br className="" id="" />
      
      <input
        name="nombrejivad"
        type="text"
        placeholder="Nombre"
        className="input "
        id="ivhhmg"
      />
      
      </div>
      
      <div id="ic08hc" className="">
      
      <label id="" className="">
      <>Correo</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="correoirnp8"
        type="text"
        placeholder="Correo"
        className="input "
        id="izzovt"
      />
      
      </div>
      
      <div id="itnvdc" className="">
      
      <label id="" className="">
      <>Teléfono</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="telfono8f0j3g"
        type="text"
        placeholder="Teléfono"
        className="input "
        id="ikvxj8"
      />
      
      </div>
      
    <div id="ilmmek" className="">
    
      <label id="" className="">
      <>mensaje</>
      </label>
      
      <br className="" id="" />
      
      <textarea className="input " id="iyhd6g">
        
      </textarea>
      
    </div>
    
      <div id="igkm1s" className="">
      
      <button
        type="submit"
        name=""
        id="iizxqw"
        className="boton-principal "
        
      >
      
      <div id="ixjn2g" className="">
      <>Enviar</>
      </div>
      
      </button>
      
      </div>
      
      </form>
      
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i82i5" className="">
      
      <div id="i3wet5" className="">
      
      <div id="iolpr7" className="">
      
      <img
        className=""
        id="i3jisj"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4nb2a7.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i9bcbd" className="">
      
        <a
          target=""
          className="link-menu "
          id="i2tta2"
          href="#sobremi"
        >
          
    <div id="ivw9gj" className="">
    <>Sobre mi</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i7rtlz"
          href="#experiencia"
        >
          
    <div id="i44uop" className="">
    <>Experiencia</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i3bw7x"
          href="#educacion"
        >
          
    <div id="ix9y1i" className="">
    <>Educación</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ik8cbw"
          href="#libros"
        >
          
    <div id="isvi9f" className="">
    <>Libros</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i71f0p"
          href="#contacto"
        >
          
    <div id="iv0dv4" className="">
    <>Contáctame</>
    </div>
    
        </a>
        
      </div>
      
      <div id="ivgr2j" className="">
      
        <a
          target="_blank"
          className=""
          id="i7cf33"
          href="https://www.instagram.com/carlosgcalix/"
        >
          
      <img
        className=""
        id="i3mnfv"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4jj58l.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ic4w45"
          href="https://www.linkedin.com/in/carlos-g-c%C3%A1lix-27b524a3/"
        >
          
      <img
        className=""
        id="iim9aw"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4jktmy.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="idipwo"
          href="https://www.facebook.com/carlosgcalix"
        >
          
      <img
        className=""
        id="i5gmgv"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4jl24g.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div id="ie26zw" className="">
      
      <div id="i4ib3g" className="">
      
      <img
        className=""
        id="ijanjc"
        src="https://assetsprojects.s3.amazonaws.com/404pziime4nhbcd.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="ia15ah"
          href="mailto:cgcalixg@gmail.com"
        >
          
    <div id="iu5j2a" className="">
    <>cgcalixg@gmail.com</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="irsy0f" className="">
      
      </div>
      
      <div className="" id="id9asw">
        <>Todos los derechos reservados ©. Carlos G. Calix 2025 </>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Ppaginaprincipalkmvgt);
  